import React, { useState, useEffect, useContext } from "react";
import Header from "../Header";
import Footer from "../Footer";
import Game from "../Game";
import LockdownScreen from "../LockdownScreen";

import HowToPlayModal from "../modals/HowToPlayModal";
import StatsModal from "../modals/StatsModal";
import InfoModal from "../modals/InfoModal";

import { Toaster } from "../ui/toaster";
import PuzzleDataProvider, { PuzzleDataContext } from "../../providers/PuzzleData";
import GameStatusProvider, { GameStatusContext } from "../../providers/GameStatus";
import { STORAGE_KEYS } from "../../lib/constants";

function AppContent() {
    // Modal states
    const [isHowToPlayOpen, setIsHowToPlayOpen] = useState(false);
    const [isStatsOpen, setIsStatsOpen] = useState(false);
    const [isInfoOpen, setIsInfoOpen] = useState(false);

    // Get loading state from PuzzleDataContext
    const { isLoading, error, isLocked } = useContext(PuzzleDataContext);

    // Get game status from context
    const { isGameOver } = useContext(GameStatusContext);

    // Show how to play on first visit (only if game is NOT already over)
    useEffect(() => {
        const hasSeenHowToPlay = localStorage.getItem(STORAGE_KEYS.hasSeenHowToPlay);
        if (!hasSeenHowToPlay) {
            localStorage.setItem(STORAGE_KEYS.hasSeenHowToPlay, "true");
            if (!isGameOver) {
                setIsHowToPlayOpen(true);
            }
        }
    }, [isGameOver]);

    const handleHelpClick = () => {
        // Only open How To Play if game is not over
        if (!isGameOver) {
            setIsHowToPlayOpen(true);
        }
    };

    // Show loading state while fetching puzzle from Firebase
    if (isLoading) {
        return (
            <div className="wrapper flex items-center justify-center min-h-screen">
                <div className="text-center">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-500 mx-auto"></div>
                    <p className="mt-4 text-gray-600">Loading puzzle...</p>
                </div>
            </div>
        );
    }

    // Show error state if puzzle loading failed (should rarely happen due to fallbacks)
    if (error) {
        console.error("Puzzle loading error:", error);
        // Continue anyway - we have fallback puzzles
    }

    // Show lockdown screen if game is locked
    if (isLocked) {
        return <LockdownScreen />;
    }

    return (
        <div className="wrapper">
            <Toaster />
            <Header
                onHelpClick={handleHelpClick}
                onStatsClick={() => setIsStatsOpen(true)}
                onInfoClick={() => setIsInfoOpen(true)}
            />
            <Game />
            <Footer />

            {/* Modals */}
            <HowToPlayModal
                isOpen={isHowToPlayOpen}
                onClose={() => setIsHowToPlayOpen(false)}
            />
            <StatsModal
                isOpen={isStatsOpen}
                onClose={() => setIsStatsOpen(false)}
            />
            <InfoModal
                isOpen={isInfoOpen}
                onClose={() => setIsInfoOpen(false)}
            />
        </div>
    );
}

function App() {
    return (
        <PuzzleDataProvider>
            <GameStatusProvider>
                <AppContent />
            </GameStatusProvider>
        </PuzzleDataProvider>
    );
}

export default App;
